'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var ErrorMessage = require('./ErrorMessage.js');
var FieldRequiredIndicator = require('./FieldRequiredIndicator.js');
var alloyInput_module = require('./alloy-input.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var RadioGroup = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, error = _a.error, label = _a.label, name = _a.name, onError = _a.onError, selected = _a.selected, setError = _a.setError, setSelected = _a.setSelected, showOptional = _a.showOptional, showRequired = _a.showRequired, _c = _a.size, size = _c === void 0 ? 'dynamic' : _c, _d = _a.buttonVariantSize, buttonVariantSize = _d === void 0 ? 'small' : _d, _e = _a.labelPlacement, labelPlacement = _e === void 0 ? 'top' : _e, validator = _a.validator, variant = _a.variant, labelClassName = _a.labelClassName;
    var isSmallButtonSize = buttonVariantSize === 'small';
    var isButtonVariant = variant === 'button';
    var shouldFloatLabel = labelPlacement === 'left' && isButtonVariant;
    var ref = react.useRef(null);
    var _f = useDefaultInternalState.default(selected, setSelected), selectedState = _f[0], setSelectedState = _f[1];
    var _g = useDefaultInternalState.default(error, setError), errorState = _g[0], setErrorState = _g[1];
    return (jsxRuntime.jsxs("fieldset", tslib.__assign({ "data-testid": "mb-3", ref: ref, className: cx__default.default('mb-3', className, {
            invalid: error,
            'd-flex': variant === 'button'
        }) }, { children: [label && (jsxRuntime.jsx("legend", tslib.__assign({ className: cx__default.default((_b = {},
                    _b[alloyInput_module.default['alloy-input__label']] = !isButtonVariant,
                    _b['float-start m-0 d-flex'] = shouldFloatLabel,
                    _b['w-auto'] = isButtonVariant,
                    _b['mb-1'] = isButtonVariant && labelPlacement === 'top',
                    _b['align-self-center'] = labelPlacement === 'left',
                    _b['u-fs--14'] = isSmallButtonSize,
                    _b['u-fs--16'] = !isSmallButtonSize,
                    _b['me-1'] = isSmallButtonSize,
                    _b['me-2'] = !isSmallButtonSize,
                    _b), labelClassName) }, { children: jsxRuntime.jsxs("div", tslib.__assign({ className: "align-self-center" }, { children: [label, (showRequired || showOptional) && (jsxRuntime.jsx(FieldRequiredIndicator.default, { showOptional: showOptional, showRequired: showRequired }))] })) }))), children &&
                react.Children.map(children, function (child) {
                    return react.cloneElement(child, {
                        hideError: true,
                        selected: selectedState,
                        setError: setErrorState,
                        setSelected: setSelectedState,
                        size: size,
                        buttonVariantSize: buttonVariantSize,
                        validator: validator,
                        variant: variant
                    });
                }), errorState && (jsxRuntime.jsx(ErrorMessage.default, tslib.__assign({ fieldName: name, inputRef: ref, onShow: onError }, { children: errorState })))] })));
};
var RadioGroup$1 = RadioGroup;

exports.default = RadioGroup$1;
//# sourceMappingURL=RadioGroup.js.map
